import {useState, useEffect, useRef} from "react";
import "./My_Projects.scss";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export default function My_Projects() {
    const sliderref = useRef();
    const containerref = useRef();
    const pagewidth = window.innerWidth;
    const [small, setsmall] = useState(false);
    useEffect(() => {
        if (pagewidth <= 480) {
            setsmall(true);
        } else if (pagewidth > 480) {
            setsmall(false);
        }
    }, small);

    const [currentSlide, setCurrentSlide] = useState(0);
    const data = [
        {
            id: "1",
            icon: "./assets/mobile.png",
            title: "GS_NOTE",
            desc:
                "Developed a comprehensive note taking app using React, Rough.js and Canvas API",
            img:
                "https://99designs-blog.imgix.net/blog/wp-content/uploads/2018/10/attachment_100040756-e1538485934255.jpeg?auto=format&q=60&fit=max&w=930",
            link: "https://gsnote-gaurav-iitb.web.app",
            laptopImg: "./assets/laptop.png",
            mobileImg: "./assets/phone.png",
            displayImg1: "./assets/scroll.png",
            displayImg2: "./assets/scroll1.jpg"
        },
        {
            id: "2",
            icon: "./assets/globe.png",
            title: "GS_OTT",
            desc:
                "A Full Stack Movie Watching MERN application using MongoDB, ExpressJS, ReactJS and NodeJS",
            img:
                "https://i.pinimg.com/originals/e9/c9/2f/e9c92f7869d682a6fa5a97fb8a298f30.jpg",
            link: "https://gs-ott-gaurav-iitb.web.app/register",
            laptopImg: "./assets/laptop.png",
            mobileImg: "./assets/phone.png",
            displayImg1: "./assets/scroll.png",
            displayImg2: "./assets/scroll1.jpg"
        },
        {
            id: "3",
            icon: "./assets/writing.png",
            title: "GS_SOCIAL",
            desc:
                "A Full Stack Social Media Application Using MERN Stack To Connect With Friends & Realtime Chatting",
            img:
                "https://i.pinimg.com/originals/a9/f6/94/a9f69465d972a004ad581f245d6ad581.jpg",
            link: "https://gs-social-gaurav-iitb.web.app/register",
            laptopImg: "./assets/laptop.png",
            mobileImg: "./assets/phone.png",
            displayImg1: "./assets/scroll.png",
            displayImg2: "./assets/scroll1.jpg"
        },

        {
            id: "4",
            icon: "./assets/writing.png",
            title: "EXPENSE MANAGER",
            desc:
                "A React Application Used For Managing Your Finances Wisely & Effortlessly",
            img:
                "https://i.pinimg.com/originals/a9/f6/94/a9f69465d972a004ad581f245d6ad581.jpg",
            link: "https://expense-gaurav-iitb.web.app",
            laptopImg: "./assets/laptop.png",
            mobileImg: "./assets/phone.png",
            displayImg1: "./assets/scroll.png",
            displayImg2: "./assets/scroll1.jpg"
        },
        {
            id: "5",
            icon: "./assets/writing.png",
            title: "GS_CALCI",
            desc:
                "A React Application Used For Performing Calculations To Make Students & Teachers Life Easy",
            img:
                "https://i.pinimg.com/originals/a9/f6/94/a9f69465d972a004ad581f245d6ad581.jpg",
            link: "https://calculator-gaurav-iitb.web.app",
            laptopImg: "./assets/laptop.png",
            mobileImg: "./assets/phone.png",
            displayImg1: "./assets/scroll.png",
            displayImg2: "./assets/scroll1.jpg"
        },
        {
            id: "6",
            icon: "./assets/writing.png",
            title: "TicTacToe",
            desc:
                "Play the classic Tic-Tac-Toe game (also called Noughts and Crosses) For Free Online",
            img:
                "https://i.pinimg.com/originals/a9/f6/94/a9f69465d972a004ad581f245d6ad581.jpg",
            link: "https://tictactoe-gaurav-iitb.web.app",
            laptopImg: "./assets/laptop.png",
            mobileImg: "./assets/phone.png",
            displayImg1: "./assets/scroll.png",
            displayImg2: "./assets/scroll1.jpg"
        },
    ];

    // const handleClick = (way) => {
    //     way === "left"
    //         ? setCurrentSlide(currentSlide > 0 ? currentSlide - 1 : 5)
    //         : setCurrentSlide(currentSlide < data.length - 1 ? currentSlide + 1 : 0);
    // };

    const [clicklimit,setclicklimit] = useState(window.innerWidth/2300);

    function handleClick(direction) {

        let scrollSpeed = containerref.current.getBoundingClientRect().width-60;

        let distance = sliderref.current.getBoundingClientRect().x - 140;

        console.log(scrollSpeed, distance)

        if (direction === "right" && currentSlide < 5 - clicklimit) {
            console.log("move", -scrollSpeed+distance)
            // setslidedl(true);
            setCurrentSlide(currentSlide + 1);
            sliderref.current.style.transform = `translateX(${-scrollSpeed + distance }px) `;
            // sliderref.current.style.transform = `translateX(${-23}px) `;
        } else if (direction === "left" && currentSlide > 0) {
            console.log("move", scrollSpeed+distance)
            setCurrentSlide(currentSlide - 1);
            sliderref.current.style.transform = `translateX(${scrollSpeed + distance}px) `;
        }
        // console.log(distance);
    }

    return (
        <div className="works" id="works">
            <div
                className="slider"
                ref={sliderref}
                // style={{transform: `translateX(-${currentSlide * 71}%) `}}
            >
                {data.map((d) => (
                    <div className="container" ref={containerref}>
                        <div className="item">
                            <div className="left">
                                <div className="leftContainer">
                                    <div className="cover">
                                        <div className="imgContainer">
                                            <img src="./assets/mobile.png" alt=""/>
                                        </div>
                                        <h2>{d.title}</h2>
                                    </div>
                                    <p className="mob-proj">{d.desc}</p>
                                    <br/>
                                    <a target="_blank" style={{textDecoration: "none", color: "green", fontWeight: "bolder"}}
                                       href={d.link}>Click To View</a>
                                </div>
                            </div>
                            <div className="right">
                                <div class="phone">
                                    {!small ? <img src={d.laptopImg} alt=""/> : <img src={d.mobileImg} alt=""/>}
                                    <div class="phoneScreen">
                                        {!small ? <img src={d.displayImg1} alt="" class="phoneApp"/> :
                                            <img src={d.displayImg2} alt="" class="phoneApp"/>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {/*<img*/}
            {/*    src="assets/arrow.png"*/}
            {/*    className="arrow left"*/}
            {/*    alt=""*/}
            {/*    onClick={() => handleClick("left")}*/}
            {/*/>*/}
            {/*<img*/}
            {/*    src="assets/arrow.png"*/}
            {/*    className="arrow right"*/}
            {/*    alt=""*/}
            {/*    onClick={() => handleClick("right")}*/}
            {/*/>*/}
            <KeyboardArrowLeftIcon
                onClick={() => handleClick("left")}
                className="arrow left"
            />
            <KeyboardArrowRightIcon
                onClick={() => handleClick("right")}
                className="arrow right"
            />
        </div>
    );
}